'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _LocationList = require('./LocationList');

var _LocationList2 = _interopRequireDefault(_LocationList);

var _ProgressBar = require('./ProgressBar');

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Constant = require('./Constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SmartSuggestResult = function (_React$Component) {
  _inherits(SmartSuggestResult, _React$Component);

  function SmartSuggestResult(props) {
    _classCallCheck(this, SmartSuggestResult);

    var _this = _possibleConstructorReturn(this, (SmartSuggestResult.__proto__ || Object.getPrototypeOf(SmartSuggestResult)).call(this, props));

    _this.state = {
      showError: false,
      isGettingGeoLocation: false
    };
    return _this;
  }

  _createClass(SmartSuggestResult, [{
    key: 'getLocation',
    value: function getLocation(event) {
      var _this2 = this;

      if (this.state.isGettingGeoLocation) return;

      this.setState({
        isGettingGeoLocation: true
      });
      event.preventDefault();
      navigator.geolocation.getCurrentPosition(function (position) {
        _this2.props.changeCurrentLocation(position);
        _this2.props.closePopup();
      }, function (err) {
        _this2.setState({
          showError: true,
          isGettingGeoLocation: false
        });
      }, {
        enableHighAccuracy: true
      });
    }
  }, {
    key: 'closeFlashMessage',
    value: function closeFlashMessage(event) {
      event.preventDefault();
      this.setState({
        showError: false
      });
    }
  }, {
    key: 'displayError',
    value: function displayError() {
      if (this.state.showError) {
        return _react2.default.createElement(
          'div',
          { className: 'flash-message-backgroud' },
          _react2.default.createElement(
            'div',
            { className: 'flash-message' },
            _react2.default.createElement('i', { className: 'rui-icon rui-icon-cross', onClick: this.closeFlashMessage.bind(this) }),
            _react2.default.createElement('i', { className: 'rui-icon rui-icon-warning' }),
            _react2.default.createElement(
              'div',
              { className: 'information' },
              _react2.default.createElement(
                'p',
                { className: 'title' },
                'Sorry, we can\u2019t access your location.'
              ),
              _react2.default.createElement(
                'p',
                { className: 'content' },
                'Make sure you allow access to location services.'
              )
            ),
            _react2.default.createElement(
              'button',
              { className: 'close-button', onClick: this.closeFlashMessage.bind(this) },
              'Close'
            )
          )
        );
      }
    }
  }, {
    key: 'renderSuggestionBox',
    value: function renderSuggestionBox() {
      return _react2.default.createElement(_LocationList2.default, { locationListResult: this.props.smartSuggestResult,
        isLoading: this.props.isLoading,
        switchToMyLocation: this.props.switchToMyLocation,
        isInMyLocation: this.props.isInMyLocation,
        locationCursor: this.props.locationCursor,
        changeCursor: this.props.changeCursor });
    }
  }, {
    key: 'renderQuickLinkColumn',
    value: function renderQuickLinkColumn(quickLinks) {
      var _this3 = this;

      return _react2.default.createElement(
        'ul',
        { className: 'quick-links-column' },
        quickLinks && quickLinks.map(function (quickLink, index) {
          return _react2.default.createElement(
            'li',
            { key: index },
            _react2.default.createElement(
              'a',
              { className: 'quick-link', onClick: function onClick() {
                  _this3.props.onClickQuickLink(quickLink);
                } },
              _react2.default.createElement('i', { className: 'icon forward' }),
              _react2.default.createElement(
                'span',
                { className: 'quick-link-text' },
                quickLink.displayValue
              )
            )
          );
        })
      );
    }
  }, {
    key: 'renderQuickLinks',
    value: function renderQuickLinks() {
      return this.props.quickLinks && _react2.default.createElement(
        'div',
        { className: 'quick-links-box' },
        _react2.default.createElement(
          'div',
          { className: 'box-header' },
          _react2.default.createElement(
            'span',
            { className: 'box-label' },
            'Quick links'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'box-body' },
          _react2.default.createElement(
            'div',
            { className: 'quick-links' },
            this.renderQuickLinkColumn(this.props.quickLinks.slice(0, 4)),
            this.renderQuickLinkColumn(this.props.quickLinks.slice(4, 8))
          )
        )
      );
    }
  }, {
    key: 'renderDoneBar',
    value: function renderDoneBar() {
      return _react2.default.createElement(
        'div',
        { className: 'done-bar' },
        _react2.default.createElement(
          'span',
          { className: 'close-popup', onClick: this.props.closePopup },
          'DONE'
        )
      );
    }
  }, {
    key: 'renderSuggestionBoxHeader',
    value: function renderSuggestionBoxHeader() {
      return _react2.default.createElement(
        'div',
        { className: 'done-bar box-header clearfix' },
        !(this.props.myLocations.length > 0 && this.props.locationInputValue.length < 2) && _react2.default.createElement(
          'span',
          { className: 'box-label' },
          'Location suggestions'
        ),
        _react2.default.createElement(
          'span',
          { className: 'close-popup', onClick: this.props.closePopup },
          'DONE'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var searchTextLocation = { displayValue: this.props.locationInputValue };
      return _react2.default.createElement(
        'div',
        { className: 'suggestion-box' },
        this.renderSuggestionBoxHeader(),
        this.props.myLocations.length === 0 && this.props.smartSuggestResult.length === 0 && this.props.locationInputValue.length < 2 && _react2.default.createElement(
          'div',
          {
            className: 'current-location',
            onClick: this.getLocation.bind(this)
          },
          _react2.default.createElement('i', { className: 'icon mappin' }),
          this.state.isGettingGeoLocation ? _react2.default.createElement(_ProgressBar2.default, null) : 'Current location'
        ),
        this.props.locationInputValue.length > 1 && _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('free-text-search', 'location-item', this.props.isInMyLocation(searchTextLocation) && 'checked', this.props.locationCursor === _Constant.DefaultFreeTextIndex && 'cursor'),
            onMouseOver: function onMouseOver(event) {
              _this4.props.changeCursor(_Constant.DefaultFreeTextIndex);
            },
            onClick: function onClick(event) {
              event.preventDefault();
              setTimeout(function () {
                _this4.props.switchToMyLocation(searchTextLocation);
              });
            } },
          'Add "',
          this.props.locationInputValue,
          '" ',
          this.props.isInMyLocation(searchTextLocation) ? _react2.default.createElement('i', { className: 'icon delete' }) : _react2.default.createElement('i', { className: 'icon add' })
        ),
        this.props.smartSuggestResult.length > 0 && this.renderSuggestionBox(),
        !(this.props.smartSuggestResult.length > 0 || this.props.myLocations.length > 0 || this.props.locationInputValue.length > 1) && this.renderQuickLinks(),
        this.displayError()
      );
    }
  }]);

  return SmartSuggestResult;
}(_react2.default.Component);

exports.default = SmartSuggestResult;